var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplementarySets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 6.57143H15.8571V4.64286C15.8571 4.288 15.5691 4 15.2143 4H8.78571C8.43086 4 8.14286 4.288 8.14286 4.64286V6.57143H4.28571C3.576 6.57143 3 7.14743 3 7.85714V18.1429C3 18.8526 3.576 19.4286 4.28571 19.4286H19.7143C20.424 19.4286 21 18.8526 21 18.1429V7.85714C21 7.14743 20.424 6.57143 19.7143 6.57143ZM14.5714 6.57143H9.42857V5.28571H14.5714V6.57143Z",
    fill: "#FF5CAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.73 12.0688V9.92676H11.26V12.0688H9.13197V13.5388H11.26V15.6808H12.73V13.5388H14.886V12.0688H12.73Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplementarySets);
export default __webpack_public_path__ + "static/media/supplementary_sets.7814619565c0b91fc20f867ba0ce8023.svg";
export { ForwardRef as ReactComponent };